import styled, { keyframes } from 'styled-components';
import Button from 'components/common/button';

const fadeIn = keyframes`
  from {
    transform: translateX(60vw);
    opacity: 0.5;
  }

  to {
      transform: translateY(0);
      opacity: 1;
  }
`;

const ModalContainer = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1300;
  position: fixed;
  touch-action: none;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
`;

const ModalBox = styled.div`
  width: 95%;
  height: 100%;
  position: absolute;
  z-index: 1400;
  right: 0;
  bottom: 0;
  background: #fff;
  animation: ${fadeIn} 0.3s ease;
  overflow-y: auto;
  ${props => props.theme.media.tablet`
    width: 85%;
  `};
`;

const PseudoContainer = styled.div`
  position: absolute;
  z-index: 1300;
  background: transparent;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const ModalTitleContainer = styled.div`
  margin-top: 60px;
  padding: 16px 36px;
  padding-top: 0;
  border-bottom: 1px solid ${props => props.theme.colors.grey};
  margin-bottom: 20px;
`;

const ModalTitle = styled.h6`
  color: ${props => props.theme.colors.textPrimary};
  font-size: 1.7rem;
  font-weight: 600;
  line-height: 1.6;
  margin: 0;
`;

const CloseButton = styled(Button)`
  top: 8px;
  left: 8px;
  color: ${props => props.theme.colors.textPrimary};
  position: absolute;
  flex: 0 0 auto;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  overflow: visible;
  font-size: 1rem;
  text-align: center;
  z-index: 100;
`;

const ModalBody = styled.div`
  margin: 0;
  padding: 16px 36px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 150px;
  min-height: 150px;
  min-width: 250px;
  margin-bottom: 15px;
  position: relative;
  background-position: center;
  background-size: cover;
  overflow: hidden;
  background-repeat: no-repeat;
  background-color: ${props => props.theme.colors.default};
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${props => props.src});
`;

export {
  ModalContainer,
  ModalBox,
  PseudoContainer,
  ModalTitleContainer,
  ModalTitle,
  CloseButton,
  ModalBody,
  ImageContainer,
};
